import { render, staticRenderFns } from "./AreaPickerConfig.vue?vue&type=template&id=0b47a352&scoped=true"
import script from "./AreaPickerConfig.vue?vue&type=script&lang=js"
export * from "./AreaPickerConfig.vue?vue&type=script&lang=js"
import style0 from "./AreaPickerConfig.vue?vue&type=style&index=0&id=0b47a352&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47a352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b47a352')) {
      api.createRecord('0b47a352', component.options)
    } else {
      api.reload('0b47a352', component.options)
    }
    module.hot.accept("./AreaPickerConfig.vue?vue&type=template&id=0b47a352&scoped=true", function () {
      api.rerender('0b47a352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/AreaPickerConfig.vue"
export default component.exports